import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  {
    path: '/controltower/',
    name: 'Control Tower',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['control_tower:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/controltower'),
  },
  {
    path: '/controltower-2/',
    name: 'Control Tower V2',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['h1b-control-tower-v2:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => {
      if (store.getters['identity/getFeatureFlagData']('multiImeiCT').value)
        return import(/* webpackChunkName: "master" */ '@/router/views/controltower-2/indexV2.vue')
      else return import(/* webpackChunkName: "master" */ '@/router/views/controltower-2/index.vue')
    },
  },
]
